import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

const rowStyles = {
  overflow: 'unset',
  wordWrap: 'break-word',
  whiteSpace: 'normal',
  padding: '0 9px'
}

export default class TableExampleComplex extends Component {
  state = {
    fixedHeader: true,
    stripedRows: false,
    showRowHover: false,
    selectable: true,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    // height: '300px',
  };

  handleToggle = (event, toggled) => {
    this.setState({
      [event.target.name]: toggled,
    });
  };

  render() {
    return (
      <div>
        <Table
          height={this.state.height}
          fixedHeader={this.state.fixedHeader}
          fixedFooter={this.state.fixedFooter}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
          style={{margin: '5px 0'}}
        >
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
            <TableRow key={0} >
              <TableRowColumn style={{ overflow: 'unset', wordWrap: 'break-word', whiteSpace: 'normal', fontWeight: 'bold' }}>汽車</TableRowColumn>
              <TableRowColumn style={rowStyles}>07:00 ~ 19:00</TableRowColumn>
              <TableRowColumn style={rowStyles}>19:00 ~ 07:00</TableRowColumn>
              <TableRowColumn style={rowStyles}>備註</TableRowColumn>
            </TableRow>
            <TableRow key={1} >
              <TableRowColumn style={{ overflow: 'unset', wordWrap: 'break-word', whiteSpace: 'normal' }}>定價</TableRowColumn>
              <TableRowColumn style={rowStyles}>50/小時</TableRowColumn>
              <TableRowColumn style={rowStyles}>10/小時</TableRowColumn>
              <TableRowColumn style={rowStyles}>每日最高上限500元</TableRowColumn>
            </TableRow>
          </TableBody>
        </Table>
        <Table
          height={this.state.height}
          fixedHeader={this.state.fixedHeader}
          fixedFooter={this.state.fixedFooter}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
          style={{margin: '8px 0'}}
        >
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
            <TableRow key={0} >
              <TableRowColumn style={{ overflow: 'unset', wordWrap: 'break-word', whiteSpace: 'normal', fontWeight: 'bold' }}>機車</TableRowColumn>
              <TableRowColumn style={rowStyles}>00:00 ~ 24:00</TableRowColumn>
              <TableRowColumn style={rowStyles}></TableRowColumn>
              <TableRowColumn style={rowStyles}>備註</TableRowColumn>
            </TableRow>
            <TableRow key={1} >
              <TableRowColumn style={{ overflow: 'unset', wordWrap: 'break-word', whiteSpace: 'normal' }}>定價</TableRowColumn>
              <TableRowColumn style={rowStyles}>20/次(隔日重新計價)</TableRowColumn>
              <TableRowColumn style={rowStyles}></TableRowColumn>
              <TableRowColumn style={rowStyles}>機車位於醫療大樓地下室停車場</TableRowColumn>
            </TableRow>
          </TableBody>
        </Table>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/priceTable.js